import { particles } from 'app/contracts/Particles';
import { HomeParticleStateType, LookupType, RepellType } from 'app/enum/Particles';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';
import { device } from 'utils/device';

export default class SpacesParticleProcessor {
	private _spacesType: number = 1;

	private _x: number;
	private _y: number;
	private _rx: number;
	private _ry: number;
	private _speed: number;

	private _repellStartCounter = 0;

	private _doExpandChange: boolean = false;
	s;
	private _expandM: 1;
	private _expandMAmount = 0.0005;
	private _deltaCounter = 0;

	constructor(
		private _p: HomeParticle,
		private _sceneProps: particles.ParticlesSceneProps
	) {}

	public tick() {
		this._startRepellCounter();

		if (this._doExpandChange) {
			this._deltaCounter += (window as any).deltaTime;

			if (this._deltaCounter >= 1) {
				this._deltaCounter--;

				if (this._expandM > 0) {
					this._expandM -= this._expandMAmount;
					this._expandMAmount *= 1.012;
				}

				this._p.orbitPath.expandMuliplier = this._expandM;
			}
		}
	}

	private _reset() {
		this._p.orbitPath.expandMuliplier = 1;
		this._doExpandChange = false;
		this._p.particlePhysics.onTargetReached = null;
		this._expandM = 1;

		this._p.counter.onTrigger = null;
		this._p.counter.active = false;

		this._p.animatedProps.setVectorStyleMovement(false);
	}

	public setSpacesStart() {
		this._homeSpacesState();
		this._p.position.disableTimelineX = true;
		this._p.activeState = HomeParticleStateType.SPACES;

		this._p.activate();
	}

	public spacesDIcon(x, y, rx, ry, speed, perpectiveArea): void {
		this._x = x;
		this._y = y;
		this._ry = ry;
		this._rx = rx;
		this._speed = speed;

		this._p.deactivateAllBehaviours(true);

		this._spacesRepellStart();



		this._p.particlePhysics.active = false;
		this._p.iconPath.scaleActive = false;

		this._p.animatedProps.setEase({
			x: 10 + Math.random() * 50,
			y: 8 + Math.random() * 40,
			scale: 30,
			alpha: 30
		});

		//Wait a little bit to trigger start for rise to top corner effect:
		this._p.counter.millsecsToFrames(50);
		this._p.counter.onTrigger = this._startDIcon.bind(this);
		this._p.counter.start();
	}

	private _startDIcon(): void {
		this._p.orbitPath.active = false;
		this._p.orbitPath.xMuliplier = this._p.orbitPath.yMuliplier = 0;

		this._p.particlePhysics.active = false;

		this._p.position.set({ x: this._x, y: this._y });

		this._p.iconPath.active = true;
		this._p.setupPath(this._p.iconPath, {
			x: [this._rx, 10],
			y: [this._ry, 10],
			speed: [this._speed, 0.002],
			scale: [0.05, 0.3],
			alpha: [0.03, 0.2]
		});
	}

	public spacesPerspectiveGrid(depth, cords, perpectiveArea, colIndex, rowIndex, animate): void {
		this._p.deactivateAllBehaviours(true);

		this._spacesRepellStart();

		this._p.depth.active = true;
		this._p.depth.perpectiveArea = perpectiveArea;
		this._p.depth.orginalCords = cords;
		this._p.depth.bounce = false;

		this._p.depth.setDepth(depth, true);

		this._p.orbitPath.active = false;
		this._p.iconPath.active = false;

		this._p.depth.getScale();

		this._p.mouseParallax.setPower({
			x: 0.01 * this._p.depth.getRatio(),
			y: 0.01 * this._p.depth.getRatio()
		});

		this._p.animatedProps.setEase({
			x: 20 - 17 * this._p.depth.getRatio(),
			y: 15 - 12 * this._p.depth.getRatio(),
			scale: 30,
			alpha: 30
		});


		this._p.orbitPath.xMuliplier = this._p.orbitPath.yMuliplier = 0;

		this._p.particlePhysics.active = false;
	}

	public setPerspectiveOrbit(perpectiveArea, cords): void {
		this._p.deactivateAllBehaviours(true);

		this._spacesRepellStart();
		this._p.mouseParallax.active = true;

		this._p.animatedProps.setVectorStyleMovement(false);
		this._p.depth.active = true;
		this._p.depth.perpectiveArea = perpectiveArea;
		this._p.depth.orginalCords = cords;
		this._p.depth.bounce = false;
		this._p.depth.scaleConfig = { min: 0.1, max: 0.25 };
		this._p.depth.alphaConfig = { min: 0.2, max: 0.65 };

		let dr = Math.random();
		let di = 1 - dr;
		this._p.depth.depth = 1 + dr * 8;
		this._p.animatedProps.setEase({
			x: 4 + 60 * dr,
			y: 4 + 40 * dr,
			scale: 5,
			alpha: 5
		});

		this._p.position.set(cords);

		this._p.counter2.triggerAtFrames = 120 + Math.round(Math.random() * 120);

		let random = Math.ceil(Math.random() * 3);
		this._p.counter2.triggerAtFrames = 60 + random * 15;
		this._p.counter2.loop = false;

		this._p.orbitPath.expandMuliplier = 1;

		this._p.counter2.onTrigger = () => {
			this._p.orbitPath.expandMuliplier = 1 + random * 0.4;

			//Now set new timer to make to 1 again:
			this._p.counter2.triggerAtFrames = 60;
			this._p.counter2.onTrigger = () => {
				this._p.orbitPath.expandMuliplier = 1;
			};
			this._p.counter2.start();
		};

		this._p.counter2.start();

		this._p.orbitPath.active = false;

		this._p.repell.active = true;
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 20;
		this._p.repell.randomisePower(100, 40);

		this._p.orbitPath.active = true;
		this._p.setupPath(this._p.orbitPath, {
			x: [90 - dr * 20, 0],
			y: [90 - dr * 20, 0],
			speed: [0.3 + Math.random() * 0.3, 0.2 * di],
			scale: [0.1, 0.2],
			alpha: [0.4, 0.8],
			direction: -1,
			randomise: { unsync: true, direction: false }
		});

		this._p.mouseParallax.setPower({
			x: 0.01 * this._p.depth.getRatio(),
			y: 0.01 * this._p.depth.getRatio()
		});
	}

	public whoozyTargets() {
		this._reset();
		this._p.deactivateAllBehaviours(true);

		this._p.animatedProps.setEase({
			x: 1,
			y: 1
		});

		this._p.animatedProps.setVectorFast();

		this._p.position.set({ x: -0.02, y: 0.22 });


		this._p.orbitPath.path = LookupType.ICON;
		this._p.orbitPath.active = true;
		this._p.orbitPath.xMuliplier = 100 + Math.random() * 400;
		this._p.orbitPath.yMuliplier = 100 + Math.random() * 400;

		this._p.animatedProps.targetScale = 0.06 + Math.random() * 0.12;
		this._p.animatedProps.targetAlpha = 0.2 + Math.random() * 0.7;

		this._p.orbitPath.speed = 0.5 + Math.random() * 0.5;
		this._p.orbitPath.randomise();

		setTimeout(() => {
			this._p.orbitPath.speed = 1 + Math.random() * 4;
		}, 3000);

		setTimeout(() => {
			this._p.orbitPath.speed = 0.5 + Math.random() * 0.5;
			this._p.orbitPath.xMuliplier = 200 + Math.random() * 200;
			this._p.orbitPath.yMuliplier = 200 + Math.random() * 200;
			this._p.position.set({ x: -0.035, y: 0.18 });
		}, 6000);

		setTimeout(() => {
			this._p.orbitPath.speed = 0.5 + Math.random() * 0.5;
			this._p.orbitPath.xMuliplier = -50 + Math.random() * 800;
			this._p.orbitPath.yMuliplier = -50 + Math.random() * 700;
		}, 7500);

		this._p.repell.active = true;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.radius = 40;
		this._p.repell.randomisePower(40, 70);
		this._p.repell.target = this._sceneProps.targets.spacesMouse;

	}

	public randomLerpLines(frame: any) {
		this._reset();
		this._p.deactivateAllBehaviours(true);

		this._p.particlePhysics.active = true;
		this._p.particleProps.sprite.blendMode = 'add';

		this._p.animatedProps.setEase({
			x: 1,
			y: 1
		});

		this._p.particlePhysics.reset();


		let count = 1;

		const frameX1 = frame.x1 + 0.005;
		const frameX2 = frame.x2 - 0.005;
		const frameWidth = frameX2 - frameX1;
		const frameXC = frameX1 + frameWidth / 2;

		const frameY1 = frame.y1 + 0.01;
		const frameY2 = frame.y2 - 0.01;
		const frameHeight = frameY2 - frameY1;
		const frameYC = frameY1 + frameHeight / 2;

		let edgeY;
		let lastX;

		this._p.particlePhysics.lerpToPosition(
			{
				x: frameX1 + Math.random() * frameWidth,
				y: frameY1 + Math.random() * frameHeight
			},
			400 + Math.random() * 1000
		);

		this._p.particlePhysics.onTargetReached = () => {
			if (count === 1) {
				this._p.particlePhysics.lerpToPosition(
					{
						x: frameXC,
						y: frameY1
					},
					400 + Math.random() * 1000
				);
			}

			if (count === 2) {
				this._p.particlePhysics.lerpToPosition(
					{
						x: frameX1 + Math.random() * frameWidth,
						y: frameY2
					},
					400 + Math.random() * 1000
				);
			}

			if (count === 3) {
				this._p.particlePhysics.lerpToPosition(
					{
						x: frameXC,
						y: frameYC
					},
					400 + Math.random() * 1000
				);
			}

			if (count === 4) {
				let direction = Math.random() < 0.5 ? -1 : 1;
				let edgeX = (frameWidth / 2) * direction;

				this._p.particlePhysics.lerpToPosition(
					{
						x: edgeX,
						y: frameYC
					},
					400 + Math.random() * 1000
				);
			}

			if (count === 5) {
				edgeY = Math.random() < 0.5 ? frameY1 : frameY2;

				this._p.particlePhysics.lerpToPosition(
					{
						x: frameXC,
						y: edgeY
					},
					400 + Math.random() * 1000
				);
			}

			if (count === 6) {
				let x = frameXC;
				let rand = Math.random();
				if (rand < 0.333333) x = frameX1 + frameWidth / 4;
				else if (rand < 0.666666) x = frameX2 - frameWidth / 4;

				this._p.particlePhysics.lerpToPosition(
					{
						x: x,
						y: frameYC
					},
					400 + Math.random() * 1000
				);

				lastX = x;
			}

			if (count === 7) {
				let x;
				edgeY = Math.random() < 0.5 ? frameY1 : frameY2;

				if (Math.random() < 0.5) x = lastX - frameWidth / 8;
				else x = lastX + frameWidth / 8;

				this._p.particlePhysics.lerpToPosition(
					{
						x: x,
						y: edgeY
					},
					400 + Math.random() * 1000
				);

				lastX = x;
			}


			count++;
		};

		this._p.repell.active = true;
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 200;
		this._p.repell.randomisePower(100, 200);
	}

	public squarePaths(config: any, frame: any) {
		this._reset();
		this._p.deactivateAllBehaviours(true);

		this._expandM = 1;
		this._expandMAmount = 0.0005;
		this._doExpandChange = config.doExpandChange;
		this._deltaCounter = 0;

		const x = config.x || 0;
		const y = config.y || 0.36;
		const expandM = config.expandM || 1;

		this._p.position.set({ x: x, y: y });

		this._p.animatedProps.setVectorStyleMovement(false);


		this._p.orbitPath.path = config.lookup;
		this._p.orbitPath.active = true;

		this._p.animatedProps.setEase({
			x: 20 + Math.random() * 20,
			y: 20 + Math.random() * 20
		});

		this._p.counter.active = true;
		this._p.counter.millsecsToFrames(1000);
		this._p.counter.onTrigger = () => {
			this._p.animatedProps.setEase(
				{
					x: 4 + Math.random() * 5,
					y: 4 + Math.random() * 4
				},
				true,
				60
			);
		};
		this._p.counter.start();


		let scaler = Math.round(Math.random() * 18);
		let jumpsX = 29;
		let jumpsY = 21;
		this._p.orbitPath.xMuliplier = (1 + scaler * jumpsX + Math.random() * (0.7 * scaler)) * expandM;
		this._p.orbitPath.yMuliplier = (1 + scaler * jumpsY + Math.random() * (0.7 * scaler)) * expandM;
		this._p.orbitPath.scaleActive = false;

		this._p.animatedProps.targetScale = 0.06 + 0.008 * scaler;
		this._p.animatedProps.targetAlpha = 0.2 + Math.random() * 0.8;
		this._p.particleProps.sprite.blendMode = 'add';

		this._p.orbitPath.speed = (0.5 + Math.random() * 4 + 0.1 * scaler) * config.speedM;
		this._p.orbitPath.randomise(false);

		this._p.repell.active = true;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.radius = 100;
		this._p.repell.randomisePower(100, 20);
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
	}

	//DROP is in the line bounce effect
	public leftDrop() {
		this._reset();
		this._p.deactivateAllBehaviours(true);
		this._spacesRepellStart();
		this._p.particlePhysics.active = true;
		this._p.particlePhysics.leftDrop('spaces');
	}

	//Burst is the physics burst:
	public burstUp() {
		this._reset();
		this._p.deactivateAllBehaviours(true);
		this._spacesRepellStart();
		this._p.particlePhysics.active = true;
		this._p.particlePhysics.burstUp();

		this._p.repell.active = true;
		this._p.repell.type = RepellType.VECTOR;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 100;
		this._p.repell.randomisePower(0.00002, 0.0000001);
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
	}

	public organicLinesStart() {
		this._p.animatedProps.targetScale = 0.1 + Math.random() * 0.1;

		this._p.animatedProps.hardSetScale(0.1 + Math.random() * 0.04);
		this._p.animatedProps.targetAlpha = 0.35 + Math.random() * 0.4;
		this._p.animatedProps.stopBreathing();
		this._p.deactivateAllBehaviours(true);

		//Base amounts =
		//increaseRate: number = 0.3,
		//maxForce: number = 3,
		//dampen = 0.87

		const ratio = (device.innerHeight / device.innerWidth) * 1.5;
		const xConfig = { increaseRate: 0.06 + Math.random() * 0.2, maxForce: 2 + Math.random() * 5, dampen: 0.5 };
		const yConfig = { increaseRate: xConfig.increaseRate * ratio, maxForce: xConfig.maxForce * ratio, dampen: 0.5 };

		this._p.animatedProps.setEase({
			x: 1 + Math.random() * 6,
			y: 1 + Math.random() * 3
		});

		this._p.animatedProps.setVectorStyleMovement(true, xConfig, yConfig);

		this._p.repell.active = true;
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 100;
		this._p.repell.randomisePower(100, 20);
	}

	public rain() {
		this._reset();
		this._p.deactivateAllBehaviours(true);
		this._spacesRepellStart();

		this._p.animatedProps.stopBreathing();
		this._p.animatedProps.hardSetScale(0.08 + Math.random() * 0.08);

		this._p.animatedProps.targetAlpha = 0.8 + Math.random() * 0.2;


		this._p.particlePhysics.active = true;
		this._p.particlePhysics.rain();

		this._p.repell.active = true;
		this._p.repell.type = RepellType.VECTOR;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 100;
		this._p.repell.randomisePower(0.00005, 0.0000001);
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
	}

	private _startRepellCounter() {
		if (this._repellStartCounter > 0) {
			this._repellStartCounter -= (window as any).deltaTime;

			if (this._repellStartCounter <= 0) {
				this._spacesRepellStart();
			}
		}
	}

	public basicGrid() {
		this._repellStartCounter = Math.random() * 60;
		this._p.deactivateAllBehaviours(true);

		this._p.animatedProps.targetX = 0;
		this._p.animatedProps.targetY = 0;

		this._p.animatedProps.targetScale = 0.17;
		this._p.animatedProps.targetAlpha = 0.7;
	}

	public lineDrop(depth, cords, perpectiveArea, colIndex, rowIndex, animate): void {
		this._p.deactivateAllBehaviours(true);

		this._spacesRepellStart();

		this._p.particlePhysics.drop();
		this._p.particlePhysics.depth = this._p.depth.active ? this._p.depth : null;
		this._p.particlePhysics.active = true;
		this._p.orbitPath.active = false;
		this._p.orbitPath.xMuliplier = this._p.orbitPath.yMuliplier = 0;

		this._p.counter.millsecsToFrames(1500);
		this._p.counter.onTrigger = this._doBurst.bind(this);
		this._p.counter.start();
	}

	private _doBurst() {
		this._p.particlePhysics.burst();
		this._p.animatedProps.targetAlpha = 0.7 + Math.random() * 0.3;
	}

	/**
	 * Set intial state of spaces scene > box particles:
	 */
	public initSpacesBoxIcon(reset: boolean = true): void {
		this._p.position.set({ x: 0.8, y: 0.45 }, true);

		if (reset) {
			this._p.deactivateAllBehaviours(true);
		}

		this._p.position.trackMouse = false;


		Math.random();

		this._p.animatedProps.targetScale = 0.2;
		this._p.animatedProps.targetAlpha = 0.7;


		this._p.orbitPath.active = true;
		this._p.setupPath(this._p.orbitPath, {
			x: [0, 9 / this._spacesType],
			y: [0, 9 / this._spacesType],
			speed: [0.2, 0.4],
			scale: [0.1, 0.2],
			alpha: [0.4, 0.8],
			direction: -1,
			randomise: { unsync: true, direction: false }
		});

		this._p.orbitPath.xMuliplier = this._p.orbitPath.yMuliplier = 0;
		this._p.orbitPath.active = false;

		this._p.mouseParallax.active = true;
		this._p.mouseParallax.setPower({
			x: 0.01 / this._spacesType,
			y: 0.01 / this._spacesType
		});

		this._p.animatedProps.setEase({
			x: 10 + Math.random() * 50,
			y: 8 + Math.random() * 40,
			scale: 30,
			alpha: 30
		});

		this._p.hover.active = false;

		this._spacesRepellStart();

		this.tick();
	}

	private _homeSpacesState(): void {
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
		this._p.position.trackMouse = false;

		return;

		let ran = Math.random();

		if (ran < 0.002) {
			this._p.animatedProps.targetScale = 10 + Math.random() * 20;
			this._p.animatedProps.targetAlpha = 0.01 + Math.random() * 0.01;
		} else if (ran < 0.005) {
			this._p.animatedProps.targetScale = 10 + Math.random() * 40;
			this._p.animatedProps.targetAlpha = 0.01 + Math.random() * 0.01;
		} else if (ran < 0.02) {
			this._p.animatedProps.targetScale = 2 + Math.random() * 2;
			this._p.animatedProps.targetAlpha = 0.01 + Math.random() * 0.01;
		} else {
			this._p.animatedProps.targetScale = 0.05 + Math.random() * 0.2;
			this._p.animatedProps.targetAlpha = 0.2 + Math.random() * 0.4;
		}

		this._p.repell.active = true;
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 100;
		this._p.repell.randomisePower(100, 20);

		this._p.orbitPath.active = true;
		this._p.setupPath(this._p.orbitPath, {
			x: [0, 9 / this._spacesType],
			y: [0, 9 / this._spacesType],
			speed: [0.2, 0.4],
			scale: [0.1, 0.2],
			alpha: [0.4, 0.8],
			direction: -1,
			randomise: { unsync: true, direction: false }
		});

		this._p.mouseParallax.active = true;
		this._p.mouseParallax.setPower({
			x: 0.03 / this._spacesType,
			y: 0.03 / this._spacesType
		});

		this._p.animatedProps.setEase({
			x: 10 + Math.random() * 50,
			y: 8 + Math.random() * 40,
			scale: 30,
			alpha: 30
		});
	}



	private _spacesRepellStart() {
		this._p.repell.active = true;
		this._p.repell.target = this._sceneProps.targets.spacesMouse;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 100;
		this._p.repell.randomisePower(100, 20);
	}
}
